var ProgramsAndProjects = function () {

	this.init = function () {
		var self = this;

		// $(window).on('resize', function() {
		// 	self.slick()
		// });

		// $(window).resize();

		this.slick();

	}

	 this.slick = function() {
		$('[data-component="programs-and-projects"] .slick').slick({

			slidesToShow: 1,
			dots: true,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			slidesToScroll: 1

		})

	}

	return this.init();
}

